import {useContext} from 'react';
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import C from "helpers/HelpConstants";
import {HelpAbility} from "helpers/HelpAbility";
import ServiciosHogarPlanesContext from 'context/ServiciosHogarPlanesContext';

let myAbilities = HelpAbility();

function Item({i, hogarPlan: hp, deleteHogarPlan, formEstado, category}){
 const {setHogarPlan} = useContext(ServiciosHogarPlanesContext);

 const handleIsUpdateForm = () => {
    setHogarPlan({...hp})
 }
 
 const handleDeleteHogarPlan = async () => {
    deleteHogarPlan({id: hp._id, category})
 }

 return (
   <tr>
      <th className="text-center" scope="row">{i + 1}</th>
      {formEstado.image && 
       <td className="text-center"> <img width="150" height="100" src={hp.image} alt={hp.plan} ></img></td>
      }
      {formEstado.subcategory &&
       <td className="text-center">{hp.subcategory}</td>
      }
      <td className="text-center">{hp.plan}</td>
      {formEstado.benefits &&
       <td className="text-center">
         <ul className="list-group list-group-flush">
          {hp.benefits.map((benefit) => (
            <li className="list-group-item" key={benefit}>{benefit}</li>
          ))}
         </ul>
       </td>
      }
      <td className="text-center">{hp.unitPrice}</td>
      {formEstado.comboPrice && 
       <td className="text-center">{hp.comboPrice}</td>
      }
      <td className="text-center">{hp.isActive ? "Activo" : "Inactivo"}</td>

      {myAbilities.hasAny([C.A.SERVICIOSHOGARPLANES.UPDATE, C.A.SERVICIOSHOGARPLANES.DELETE]) && <td className="text-center d-flex">
          {myAbilities.has(C.A.SERVICIOSHOGARPLANES.UPDATE) && 
          <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Editar</Tooltip>}>
              <button type="button"
                      className="btn btn-sm btn-success me-2"
                      onClick={handleIsUpdateForm}>
                  <i className="bi bi-pencil-square"/>
              </button>
          </OverlayTrigger>}
          {myAbilities.has(C.A.SERVICIOSHOGARPLANES.DELETE) && 
          <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Eliminar</Tooltip>}>
              <button type="button"
                      className="btn btn-sm btn-danger"
                      onClick={handleDeleteHogarPlan}>
                  <i className="bi bi-trash"/>
              </button>
          </OverlayTrigger>}
      </td>}
  </tr>
 )
}
export default Item

